import { call, put, takeLatest, all, fork } from "redux-saga/effects"
import { toast } from "react-toastify"
import * as types from "./actionTypes"
import * as actions from "./actions"
import {
  apiBuscarAreaArmazenamento,
  apiBuscarAreasArmazenamento,
  apiCadastrarAreaArmazenamento,
  apiEditarAreaArmazenamento,
  apiRemoverAreaArmazenamento,
  apiDuplicarAreaArmazenamento,
} from "../../helpers/backend_helper"


function* fetchAreas({ payload }) {
  try {
    const { filters } = payload
    const response = yield call(apiBuscarAreasArmazenamento, filters)
    actions.fetchAreasSuccess(response)
  } catch (error) {
    const errorMessage =
      error.response?.message ||
      error.message ||
      "Erro ao buscar áreas de armazenamento"
    yield put(actions.fetchAreasFailure(errorMessage))
    toast.error(errorMessage)
  }
}

function* fetchAreaById({ payload }) {
  try {
    const { id } = payload
    const response = yield call(apiBuscarAreaArmazenamento, id)
    yield put(actions.fetchAreaByIdSuccess(response))

  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "Erro ao buscar área de armazenamento"
    yield put(actions.fetchAreaByIdFailure(errorMessage))
    toast.error(errorMessage)
  }
}

function* createArea({ payload }) {
  try {
    const { data, callback } = payload
    const response = yield call(apiCadastrarAreaArmazenamento, data)
    yield put(actions.createAreaSuccess(response))
    swal({ title: "Inclusão realizado com sucesso!", icon: "success" }).then()

    if (callback && typeof callback === "function") {
      callback(response)
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "Erro ao criar área de armazenamento"
    yield put(actions.createAreaFailure(errorMessage))
    toast.error(errorMessage)
  }
}

function* updateArea({ payload }) {
  try {
    const { id, data, callback } = payload
    const response = yield call(apiEditarAreaArmazenamento, id, data)
    yield put(actions.updateAreaSuccess(response))
    swal({ title: "Área de armazenamento atualizada com sucesso", icon: "success" }).then()

    if (callback && typeof callback === "function") {
      callback(response)
    }
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      "Erro ao atualizar área de armazenamento"
    yield put(actions.updateAreaFailure(errorMessage))
    swal({ title: errorMessage, icon: "error" }).then()
    toast.error(errorMessage)
  }
}

function* deleteArea({ payload }) {
  try {
    const { id, callback } = payload
    const response = yield call(apiRemoverAreaArmazenamento, id)
    yield put(actions.deleteAreaSuccess(response))
    swal({ title: "Área de armazenamento removida com sucesso", icon: "success" }).then()

    if (callback && typeof callback === "function") {
      callback(response)
    }
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      "Erro ao remover área de armazenamento"
    yield put(actions.deleteAreaFailure(errorMessage))
    toast.error(errorMessage)
  }
}

function* duplicateArea({ payload }) {
  try {
    const { id, callback } = payload
    const response = yield call(apiDuplicarAreaArmazenamento, id)
    yield put(actions.duplicateAreaSuccess(response))
    swal({ title: "Área de armazenamento duplicada com sucesso", icon: "success" }).then()

    if (callback && typeof callback === "function") {
      callback(response)
    }
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      "Erro ao duplicar área de armazenamento"
    yield put(actions.duplicateAreaFailure(errorMessage))
    toast.error(errorMessage)
  }
}

export function* fetchArea() {
  yield takeLatest(types.FETCH_AREAS_REQUEST, fetchAreas)
  yield takeLatest(types.FETCH_AREA_BY_ID_REQUEST, fetchAreaById)
}

export function* requestArea() {
  yield takeLatest(types.CREATE_AREA_REQUEST, createArea)
  yield takeLatest(types.UPDATE_AREA_REQUEST, updateArea)
  yield takeLatest(types.DELETE_AREA_REQUEST, deleteArea)
  yield takeLatest(types.DUPLICATE_AREA_REQUEST, duplicateArea)
}

function* AreasSaga() {
  yield all([fork(fetchArea)])
  yield all([fork(requestArea)])
}

export default AreasSaga
